import React from 'react';
import { motion } from 'framer-motion';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import GuestChatWidget from './GuestChatWidget';
import './landing.scss';
import SeoHead from '../../../Components/Common/SeoHead';

const Community: React.FC = () => {
  const platforms = [
    {
      name: 'Discord',
      description: 'Join our active Discord community. Get instant help, share tips, and connect with fellow dropshippers.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
        </svg>
      ),
      members: '5,200+',
      color: '#5865F2',
      link: 'https://discord.gg/coderom',
      buttonText: 'Join Discord'
    },
    {
      name: 'Facebook Group',
      description: 'Be part of our private Facebook community. Weekly live sessions, Q&A, and exclusive content.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      members: '8,500+',
      color: '#1877F2',
      link: 'https://facebook.com/groups/coderom',
      buttonText: 'Join Group'
    },
    {
      name: 'YouTube',
      description: 'Subscribe for weekly tutorials, case studies, and dropshipping tips from industry experts.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
      members: '12K+',
      color: '#FF0000',
      link: 'https://youtube.com/@coderom',
      buttonText: 'Subscribe'
    },
    {
      name: 'Twitter/X',
      description: 'Follow us for daily tips, platform updates, and industry news. Join the conversation.',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      ),
      members: '15K+',
      color: '#000000',
      link: 'https://twitter.com/coderom_io',
      buttonText: 'Follow Us'
    }
  ];

  const benefits = [
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      title: 'Connect with Sellers',
      description: 'Network with thousands of successful dropshippers from around the world.'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      ),
      title: 'Get Expert Help',
      description: 'Ask questions and get answers from our team and experienced community members.'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ),
      title: 'Share Success',
      description: 'Celebrate wins, share strategies, and inspire others with your journey.'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      ),
      title: 'Exclusive Content',
      description: 'Access members-only tips, tutorials, and early feature announcements.'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        </svg>
      ),
      title: 'Live Events',
      description: 'Join weekly live Q&A sessions, workshops, and community meetups.'
    },
    {
      icon: (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
      ),
      title: 'Stay Updated',
      description: 'Be the first to know about new features, platform changes, and opportunities.'
    }
  ];

  const testimonials = [
    {
      quote: "The Discord community is amazing! Got my first sale within a week of joining and learning from other members.",
      author: "Mike T.",
      role: "eBay Seller, UK",
      avatar: "M"
    },
    {
      quote: "I love the Facebook group's live sessions. The tips shared there helped me increase my margins by 15%.",
      author: "Sarah K.",
      role: "Dropshipper, Germany",
      avatar: "S"
    },
    {
      quote: "Found my best supplier through a recommendation in the community. The networking value is incredible.",
      author: "David L.",
      role: "Multi-store Owner",
      avatar: "D"
    }
  ];

  const stats = [
    { value: '25K+', label: 'Community Members' },
    { value: '100+', label: 'Countries' },
    { value: '500+', label: 'Daily Messages' },
    { value: '50+', label: 'Weekly Events' }
  ];

  return (
    <div className="layout-wrapper landing">
      <SeoHead
        title="CodeRom Community for eBay Sellers"
        description="Join the CodeRom dropshipping community — share strategies, get help, grow your store."
      />
      <Navbar />
    <div className="community-page">
      {/* Hero */}
      <section className="community-hero">
        <div className="hero-bg">
          <div className="hero-shapes">
            <div className="shape shape-1" />
            <div className="shape shape-2" />
            <div className="shape shape-3" />
          </div>
        </div>
        <Container>
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
                        <div className="hero-badge">
              <span className="badge-pulse" />
              Join 25,000+ Dropshippers
            </div>
            <h1>Welcome to the <span>CodeRom Community</span></h1>
            <p>Connect, learn, and grow with the most active dropshipping community. Share strategies, get help, and celebrate wins together.</p>

            {/* Stats */}
            <div className="hero-stats">
              {stats.map((stat, index) => (
                <motion.div
                  key={index}
                  className="stat-item"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 + index * 0.1 }}
                >
                  <span className="stat-value">{stat.value}</span>
                  <span className="stat-label">{stat.label}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </Container>
      </section>

      {/* Platforms */}
      <section className="platforms-section">
        <Container>
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2>Join Us Everywhere</h2>
            <p>Choose your favorite platform and start connecting today</p>
          </motion.div>

          <Row className="g-4">
            {platforms.map((platform, index) => (
              <Col lg={3} md={6} key={index}>
                <motion.div
                  className="platform-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ y: -8, boxShadow: '0 20px 40px rgba(0,0,0,0.12)' }}
                  style={{ '--platform-color': platform.color } as React.CSSProperties}
                >
                  <div className="platform-icon" style={{ background: platform.color }}>
                    {platform.icon}
                  </div>
                  <h3>{platform.name}</h3>
                  <span className="member-count">{platform.members} members</span>
                  <p>{platform.description}</p>
                  <a href={platform.link} target="_blank" rel="noopener noreferrer" className="platform-btn" style={{ background: platform.color }}>
                    {platform.buttonText}
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                  </a>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Benefits */}
      <section className="benefits-section">
        <Container>
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2>Why Join Our Community?</h2>
            <p>More than just a group - it's your success network</p>
          </motion.div>

          <Row className="g-4">
            {benefits.map((benefit, index) => (
              <Col lg={4} md={6} key={index}>
                <motion.div
                  className="benefit-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                >
                  <div className="benefit-icon">{benefit.icon}</div>
                  <h4>{benefit.title}</h4>
                  <p>{benefit.description}</p>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <Container>
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2>What Members Say</h2>
            <p>Real feedback from our community members</p>
          </motion.div>

          <Row className="g-4">
            {testimonials.map((testimonial, index) => (
              <Col lg={4} key={index}>
                <motion.div
                  className="testimonial-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <div className="quote-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" opacity="0.2">
                      <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                    </svg>
                  </div>
                  <p className="quote-text">"{testimonial.quote}"</p>
                  <div className="quote-author">
                    <div className="author-avatar">{testimonial.avatar}</div>
                    <div className="author-info">
                      <span className="author-name">{testimonial.author}</span>
                      <span className="author-role">{testimonial.role}</span>
                    </div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CTA */}
      <section className="community-cta">
        <Container>
          <motion.div
            className="cta-wrapper"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="cta-content">
              <h2>Ready to Join?</h2>
              <p>Start connecting with thousands of dropshippers today. It's free!</p>
              <div className="cta-buttons">
                <a href="https://discord.gg/coderom" className="btn-discord" target="_blank" rel="noopener noreferrer">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                  </svg>
                  Join Discord Server
                </a>
                <a href={`${process.env.REACT_APP_APP_URL || ''}/register`} className="btn-trial">
                  Start Free Trial
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </a>
              </div>
            </div>
          </motion.div>
        </Container>
      </section>

      <style>{`
        .community-page {
          min-height: 100vh;
          background: #f8fafc;
        }

        .community-hero {
          position: relative;
          padding: 120px 0 80px;
          overflow: hidden;
        }

        .hero-bg {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(30, 41, 59, 0.72) 0%, rgba(15, 23, 42, 0.55) 100%),
                      url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80') center/cover no-repeat;
        }

        .hero-shapes {
          position: absolute;
          inset: 0;
          overflow: hidden;
        }

        .shape {
          position: absolute;
          border-radius: 50%;
          filter: blur(60px);
        }

        .shape-1 {
          width: 400px;
          height: 400px;
          background: rgba(249, 115, 22, 0.15);
          top: -100px;
          right: -100px;
        }

        .shape-2 {
          width: 300px;
          height: 300px;
          background: rgba(99, 102, 241, 0.15);
          bottom: -50px;
          left: -50px;
        }

        .shape-3 {
          width: 200px;
          height: 200px;
          background: rgba(16, 185, 129, 0.1);
          top: 50%;
          left: 30%;
        }

        .hero-content {
          position: relative;
          z-index: 1;
          text-align: center;
          color: white;
        }

        .back-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          font-size: 14px;
          margin-bottom: 32px;
          transition: color 0.2s;
        }

        .back-link:hover {
          color: white;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 10px 20px;
          background: rgba(255,255,255,0.1);
          border: 1px solid rgba(255,255,255,0.2);
          border-radius: 30px;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 24px;
        }

        .badge-pulse {
          width: 10px;
          height: 10px;
          background: #22c55e;
          border-radius: 50%;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.5); }
        }

        .community-hero h1 {
          font-size: 52px;
          font-weight: 800;
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .community-hero h1 span {
          background: linear-gradient(135deg, #f97316, #fb923c);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .community-hero > .hero-content > p {
          font-size: 20px;
          opacity: 0.8;
          max-width: 600px;
          margin: 0 auto 40px;
          line-height: 1.6;
        }

        .hero-stats {
          display: flex;
          justify-content: center;
          gap: 48px;
          flex-wrap: wrap;
        }

        .stat-item {
          text-align: center;
        }

        .stat-value {
          display: block;
          font-size: 32px;
          font-weight: 800;
          color: #f97316;
        }

        .stat-label {
          font-size: 14px;
          opacity: 0.7;
        }

        .section-header {
          text-align: center;
          margin-bottom: 48px;
        }

        .section-header h2 {
          font-size: 36px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 12px;
        }

        .section-header p {
          color: #64748b;
          font-size: 18px;
        }

        .platforms-section {
          padding: 80px 0;
        }

        .platform-card {
          background: white;
          border-radius: 20px;
          padding: 32px;
          text-align: center;
          box-shadow: 0 4px 20px rgba(0,0,0,0.05);
          border: 1px solid #e2e8f0;
          transition: all 0.3s;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .platform-card:hover {
          border-color: var(--platform-color);
        }

        .platform-icon {
          width: 64px;
          height: 64px;
          margin: 0 auto 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          color: white;
        }

        .platform-card h3 {
          font-size: 20px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 8px;
        }

        .member-count {
          display: inline-block;
          padding: 4px 12px;
          background: #f1f5f9;
          color: #64748b;
          font-size: 13px;
          font-weight: 600;
          border-radius: 16px;
          margin-bottom: 16px;
        }

        .platform-card p {
          font-size: 14px;
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 24px;
          flex: 1;
        }

        .platform-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 24px;
          color: white;
          text-decoration: none;
          font-weight: 600;
          font-size: 14px;
          border-radius: 10px;
          transition: all 0.2s;
        }

        .platform-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.2);
          color: white;
        }

        .benefits-section {
          padding: 80px 0;
          background: white;
        }

        .benefit-card {
          padding: 28px;
          border-radius: 16px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          transition: all 0.3s;
          height: 100%;
        }

        .benefit-card:hover {
          border-color: #f97316;
          background: white;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        }

        .benefit-icon {
          width: 52px;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #fff7ed, #ffedd5);
          border-radius: 14px;
          color: #f97316;
          margin-bottom: 20px;
        }

        .benefit-card h4 {
          font-size: 18px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 10px;
        }

        .benefit-card p {
          font-size: 14px;
          color: #64748b;
          line-height: 1.6;
          margin: 0;
        }

        .testimonials-section {
          padding: 80px 0;
        }

        .testimonial-card {
          background: white;
          border-radius: 20px;
          padding: 32px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.05);
          border: 1px solid #e2e8f0;
          height: 100%;
        }

        .quote-icon {
          margin-bottom: 16px;
          color: #f97316;
        }

        .quote-text {
          font-size: 16px;
          color: #374151;
          line-height: 1.7;
          margin-bottom: 24px;
          font-style: italic;
        }

        .quote-author {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .author-avatar {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: linear-gradient(135deg, #f97316, #fb923c);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 16px;
        }

        .author-info {
          display: flex;
          flex-direction: column;
        }

        .author-name {
          font-size: 15px;
          font-weight: 600;
          color: #1e293b;
        }

        .author-role {
          font-size: 13px;
          color: #64748b;
        }

        .community-cta {
          padding: 80px 0;
          background: linear-gradient(135deg, #1e293b, #0f172a);
        }

        .cta-wrapper {
          text-align: center;
        }

        .cta-content h2 {
          font-size: 36px;
          font-weight: 700;
          color: white;
          margin-bottom: 12px;
        }

        .cta-content p {
          font-size: 18px;
          color: rgba(255,255,255,0.7);
          margin-bottom: 32px;
        }

        .cta-buttons {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .btn-discord {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 16px 32px;
          background: #5865F2;
          color: white;
          text-decoration: none;
          font-weight: 600;
          border-radius: 12px;
          transition: all 0.3s;
        }

        .btn-discord:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(88, 101, 242, 0.4);
          color: white;
        }

        .btn-trial {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 16px 32px;
          background: linear-gradient(135deg, #f97316, #fb923c);
          color: white;
          text-decoration: none;
          font-weight: 600;
          border-radius: 12px;
          transition: all 0.3s;
        }

        .btn-trial:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(249, 115, 22, 0.4);
          color: white;
        }

        @media (max-width: 768px) {
          .community-hero h1 {
            font-size: 32px;
          }

          .hero-stats {
            gap: 24px;
          }

          .stat-value {
            font-size: 24px;
          }

          .section-header h2 {
            font-size: 28px;
          }

          .cta-content h2 {
            font-size: 28px;
          }

          .cta-buttons {
            flex-direction: column;
            align-items: center;
          }
        }
      `}</style>
    </div>
    <Footer />
      <GuestChatWidget />
    </div>
  );
};

export default Community;
